export default "__VITE_ASSET__BvhmxYVI__"